import { render, staticRenderFns } from "./areaManage.vue?vue&type=template&id=64c440d7&scoped=true&"
import script from "./areaManage.vue?vue&type=script&lang=js&"
export * from "./areaManage.vue?vue&type=script&lang=js&"
import style0 from "./areaManage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./areaManage.vue?vue&type=style&index=1&id=64c440d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c440d7",
  null
  
)

export default component.exports